// First-touch marketing attribution captured in the browser.
//
// We record the visitor's *first* landing (UTM params + referrer) once and keep
// it, so even if they navigate around before optimizing/paying, the conversion
// is still credited to the ad/campaign that brought them in. The backend stores
// it only when it first creates the account, so re-sending on every balance
// call is harmless.

const STORAGE_KEY = 'ra_attribution';
const UTM_FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

// Capture first-touch attribution once, on the first page load we ever see for
// this browser. No-op on every later visit.
export function captureFirstTouch(): void {
  try {
    if (localStorage.getItem(STORAGE_KEY)) return; // already captured
    const params = new URLSearchParams(window.location.search);
    const attr: Record<string, string> = {};
    UTM_FIELDS.forEach((f) => {
      const v = params.get(f);
      if (v) attr[f] = v;
    });
    if (document.referrer) attr.referrer = document.referrer;
    attr.landing_path = window.location.pathname;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(attr));
  } catch {
    /* localStorage unavailable (private mode) — attribution is best-effort */
  }
}

// Stored first-touch attribution as a query string (incl. leading '?'), to
// append to the balance call so the backend can persist it on account creation.
export function attributionQuery(): string {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return '';
    const qs = new URLSearchParams(JSON.parse(raw) as Record<string, string>).toString();
    return qs ? `?${qs}` : '';
  } catch {
    return '';
  }
}
